import React from "react";
import { connect } from "react-redux";
import App from "../App/App.js";
import * as actions from "../../actions/index";
import mediaData from "../../data/mediaData.json";

class AppData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allImagesLoaded: false,
      allVideoTransitionsLoaded: false,
      allVideoLoopsLoaded: false,
      progress: 0
    };
    this.fetchMedia = this.fetchMedia.bind(this);
    this.preloadMedia = this.preloadMedia.bind(this);
    this.imagesFetched = 0;
    this.imagesExpected = Object.keys(mediaData).length;
  }
  componentDidMount() {
    this.preloadMedia();
  }
  // createArrayFromObject(object, key) {
  //   return Object.keys(object).map(el => {
      
  //   });
  // }
  fetchMedia(pathObject, mediaType) {
    fetch(pathObject.src, { cache: "force-cache" })
      .then(res => {
        if (res.ok) {
          if (mediaType === "image") {
            this.newImageLoaded();
            this.areAllImagesLoaded();
          }

          return res.blob();
        }
        throw new Error("Network response was not ok.");
      })
      .then(blob => {
        pathObject.src = window.URL.createObjectURL(blob);
      });
  }
  newImageLoaded() {
    this.imagesFetched++;
    this.setState({
      progress: Math.ceil((this.imagesFetched / this.imagesExpected) * 100)
    });
  }
  areAllImagesLoaded() {
    if (this.imagesFetched === this.imagesExpected) {
      setTimeout(() => {
        this.setState({
          allImagesLoaded: true
        });
      }, 200);
    }
  }
  preloadMedia() {
    // TODO: Dynamically generate these values instead of hardcoding
    const videosExpected = Object.keys(mediaData).length - 1;
    const videoLoopsExpected = 5;
    let videosFetched = 0;
    let videoLoopsFetched = 0;
    for (let key in mediaData) {
      if ("image" in mediaData[key]) {
        this.fetchMedia(mediaData[key].image, "image"); // async === non-blocking
      }
      if ("videoLoop" in mediaData[key]) {
        this.fetchMedia(mediaData[key].videoLoop, "video");
        videoLoopsFetched++;
        if (videoLoopsFetched === videoLoopsExpected) {
          this.setState({ allVideoLoopsLoaded: true });
        }
      }
      if ("videoTransition" in mediaData[key]) {
        this.fetchMedia(mediaData[key].videoTransition, "video");
        videosFetched++;
        if (videosFetched === videosExpected) {
          this.setState({ allVideoTransitionsLoaded: true });
        }
      }
    }
  }
  render() {
    return (
      <App
        mediaData={mediaData}
        allImagesLoaded={this.state.allImagesLoaded}
        allVideoTransitionsLoaded={this.state.allVideoTransitionsLoaded}
        allVideoLoopsLoaded={this.state.allVideoLoopsLoaded}
        progress={this.state.progress}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    loader: state.navigation.loader
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLoader: bool => {
      dispatch(actions.setLoader(bool));
    },
    setLoaderProgress: percentage => {
      dispatch(actions.setLoaderProgress(percentage));
    }
  };
}

AppData.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppData);
